module.exports = __webpack_public_path__ + "img/live-empty.2511cf27.png";